import TaskGoals from './TaskGoals';

export default TaskGoals;
